if (!customElements.get('product-form')) {
  const wbdText = (key, fallback) => window.variantStrings?.wbd?.[key] || fallback;
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.form || !this.submitButton) return;
      this.variantIdInput.disabled = false;
      this.submitButtonText = this.submitButton.querySelector('span');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      if (this.pending || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.pending = true;
      this.setLoading(true);
      const formData = new FormData(this.form);
      const ids = this.cart?.getSectionsToRender().map((section) => section.id) || [];
      if (this.cart) {
        formData.set('sections', ids.join(','));
        formData.set('sections_url', location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      let added = false;
      try {
        await window.WBDCart.run(async () => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const response = await window.WBDCart.request(routes.cart_add_url, { ...config, body: formData });
          added = true;
          const result = await window.WBDCart.finish(response, ids);
          this.dispatchEvent(new CustomEvent('wbd:product-added', { bubbles: true, detail: { variantId: formData.get('id') } }));
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(true);
          if (!this.cart) { location.assign(routes.cart_url); return; }
          try { this.cart.renderContents(result); }
          catch {
            this.showFeedback(wbdText('added', 'Toegevoegd aan je winkelwagen, maar de weergave kon niet worden vernieuwd. Open je winkelwagen om verder te gaan.'), 'warning');
            return;
          }
          this.showFeedback(wbdText('added_success', 'Toegevoegd aan je winkelwagen.'), 'success');
          if (result.wbdWarning) this.cart.showFeedback?.(result.wbdWarning, 'warning');
          await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: result, wbdRendered: true });
        });
      } catch (error) {
        const message = added ? 'Toegevoegd aan je winkelwagen. Open je winkelwagen om de actuele inhoud te bekijken.' : error instanceof TypeError ? wbdText('unconfirmed', 'Toevoegen kon niet worden bevestigd. Controleer je winkelwagen voordat je opnieuw probeert.') : error.message;
        this.showFeedback(message, added ? 'warning' : 'error');
        if (!added) await publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), message }).catch(() => {});
      } finally {
        this.pending = false;
        this.setLoading(false);
        if (!added && this.isConnected && !this.submitButton.disabled) this.submitButton.focus({ preventScroll: true });
      }
    }

    setLoading(loading) {
      this.submitButton.classList.toggle('loading', loading);
      this.submitButton.toggleAttribute('aria-disabled', loading);
      this.form.setAttribute('aria-busy', String(loading));
      this.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      this.form.dispatchEvent(new CustomEvent('wbd:product-loading', { bubbles: true, detail: { loading } }));
    }

    handleErrorMessage(message = '') {
      this.showFeedback(message, 'error');
    }

    showFeedback(message = '', state = 'error') {
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper && message) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        const text = document.createElement('span');
        text.className = 'product-form__error-message';
        const link = document.createElement('a');
        link.href = routes.cart_url;
        link.textContent = wbdText('cart_link', 'Winkelwagen');
        wrapper.append(text, link);
        this.prepend(wrapper);
      }
      if (wrapper) {
        wrapper.dataset.feedbackState = state;
        wrapper.setAttribute('role', state === 'error' ? 'alert' : 'status');
        wrapper.setAttribute('aria-atomic', 'true');
        wrapper.hidden = !message;
        wrapper.querySelector('.product-form__error-message').textContent = message;
      }
    }

    toggleSubmitButton(disable = true, text) {
      this.submitButton.disabled = disable;
      if (this.submitButtonText) this.submitButtonText.textContent = text || window.variantStrings.addToCart;
    }

    get variantIdInput() { return this.form.querySelector('[name="id"]'); }
  });
}
